import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { KineticLines, Reveal } from "../Reveal";

export default function FinalCTA() {
  return (
    <section className="relative bg-navy-950 text-white overflow-hidden grain" data-testid="final-cta">
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1440 720" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <path d="M-120 560 C 240 460, 420 640, 760 500 C 1080 370, 1240 520, 1560 380" stroke="#15B8A6" strokeWidth="2" strokeOpacity="0.75" strokeDasharray="6 12" className="animate-dashFlow" />
        <path d="M-120 620 C 280 520, 480 700, 820 560 C 1120 440, 1300 580, 1560 450" stroke="#3D6BA8" strokeWidth="1.6" strokeOpacity="0.6" strokeDasharray="5 13" className="animate-dashFlow" style={{ animationDelay: "0.5s" }} />
        <path d="M-120 480 C 260 400, 480 560, 820 440 C 1120 330, 1300 460, 1560 320" stroke="#8FB3D9" strokeWidth="1.2" strokeOpacity="0.45" strokeDasharray="4 14" className="animate-dashFlow" style={{ animationDelay: "1s" }} />
        <circle r="5" fill="#2BD4C1">
          <animateMotion dur="9s" repeatCount="indefinite" path="M-120 560 C 240 460, 420 640, 760 500 C 1080 370, 1240 520, 1560 380" />
        </circle>
        <circle r="3.5" fill="#8FB3D9">
          <animateMotion dur="11s" begin="-4s" repeatCount="indefinite" path="M-120 620 C 280 520, 480 700, 820 560 C 1120 440, 1300 580, 1560 450" />
        </circle>
      </svg>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider2 text-teal-bright">
            <span className="h-px w-8 bg-teal-bright" aria-hidden="true" />
            Start The Conversation
          </span>
        </Reveal>
        <KineticLines
          as="h2"
          className="mt-6 font-display font-extrabold tracking-tightest text-3xl sm:text-5xl lg:text-6xl leading-[1.06] text-white"
          lines={["A Healthier Bottom Line", <>Starts With <span className="text-teal-bright">One Good Conversation.</span></>]}
        />
        <Reveal delay={0.12}>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-ice/75 max-w-2xl mx-auto">
            You've worked hard to build your business. Let's explore whether there are opportunities to help you
            keep more of what you've earned.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid="final-cta-primary"
              className="group inline-flex items-center gap-2 bg-teal text-navy font-bold text-[15px] px-8 py-4 rounded-full transition-all duration-300 hover:bg-teal-bright hover:-translate-y-0.5 shadow-[0_16px_40px_-12px_rgba(21,184,166,0.5)]"
            >
              Start My Savings Review
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/contact"
              data-testid="final-cta-secondary"
              className="inline-flex items-center gap-2 border border-white/25 text-white font-bold text-[15px] px-8 py-4 rounded-full transition-all duration-300 hover:border-teal-bright hover:text-teal-bright"
            >
              Contact Our Team
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-14 text-[12px] font-bold uppercase tracking-wider2 text-ice/50">
            Helping Good Businesses Keep More of What They Earn.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
